<template>
  <router-view />
</template>

<style lang="scss">
@import "@/static/scss/styles.scss";
</style>
